import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import './AuditTrail.css';

const truncate = (value, len = 80) => {
  if (!value && value !== 0) return '';
  const s = String(value);
  return s.length > len ? s.slice(0, len) + '…' : s;
};

const AuditTrail = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await api.get('/audit');
        setLogs(res.data || []);
      } catch (err) {
        setError(err?.response?.data?.error || err.message || 'Failed to fetch audit logs');
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  return (
    <div className="audit-trail">
      

      {loading && <div>Loading...</div>}
      {error && <div className="text-danger">{error}</div>}
      {!loading && logs.length === 0 && !error && <div className="text-muted">No audit entries found.</div>}

      {logs.length > 0 && (
        <div className="table-wrap">
          <table className="audit-table">
            <thead>
              <tr>
                <th>Action</th>
                <th>Table</th>
                <th>Record ID</th>
                <th>User</th>
                <th>Recorded On</th>
                <th>Old</th>
                <th>New</th>
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>
              {logs.map(l => (
                <tr key={l.auditLogID}>
                  <td className="col-action">{l.action}</td>
                  <td className="col-table">{l.tableName}</td>
                  <td className="col-record">{l.recordID}</td>
                  <td className="col-user">{l.userID ?? 'System'}</td>
                  <td className="col-when">{new Date(l.timestamp).toLocaleString()}</td>
                  <td className="col-old" title={l.oldValue}>{truncate(l.oldValue, 100)}</td>
                  <td className="col-new" title={l.newValue}>{truncate(l.newValue, 100)}</td>
                  <td className="col-reason">{l.reason}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AuditTrail;
